import { useContext, useState } from 'react';

import google from 'app/lib/google';
import { useAnalyticsContext } from 'app/shared/utils';
import { useIsBreakpointSize } from 'app/shared/utils/useBreakpoint';
import { useVisaAuth } from 'app/shared/utils/visa';
import { Event } from 'app/shared/typings';
import { AuthContext } from 'app/shared/context/Auth';
import { ThirdPartyPaymentMethodType } from 'app/fan/utils/checkout';

export const useTrackProductAdded = (
  event?: Event | null,
  isExpressCheckout?: boolean
) => {
  const { trackAnalyticsEvent } = useAnalyticsContext();
  const { loggedIn, user } = useContext(AuthContext);
  const { visaPreSaleEligible } = useVisaAuth({
    eventId: Number(event?.id),
    skipLoadCardRedemptionsStatus: true,
  });
  const { isMobile } = useIsBreakpointSize();

  const [sentGoogleDataLayer, setSentGoogleDataLayer] = useState(false);

  // Unless this is triggered from Express Checkout, we don't yet know the payment method type,
  // so we will default the value to undefined if nothing is passed in
  function trackProductAdded(paymentMethodType?: ThirdPartyPaymentMethodType) {
    if (!event) {
      return;
    }

    if (!sentGoogleDataLayer) {
      google.dataLayer({ event: 'Product Added', event_id: event.id });
      setSentGoogleDataLayer(true);
    }

    trackAnalyticsEvent(
      'Product Added',
      {
        content_ids: [event.id],
        content_type: 'product',
        currency: event.city.currencyCode?.toUpperCase(),
        city_slug: event.city.cachedSlug,
        value: event.price || 0,
        is_visa_validated: visaPreSaleEligible,
        is_mobile: isMobile,
        checkout_version: 2,
        category: event.type,
        event_owner_type: event.eventOrganizedAs,
        is_express_checkout: !!isExpressCheckout,
        is_guest_checkout: !loggedIn,
        user_id: user?.id,
        payment_method_type: paymentMethodType,
        product_id: event.id, // Snapchat needs this, please do not remove
        email: user?.email?.toLowerCase().trim(), // Snapchat needs this, please do not remove
      },
      true
    );
  }

  return { trackProductAdded };
};
